import { LabelValues } from 'Modules'

export const enum TokenTypeEnum {
  MEY = 0,
  USDC = 1,
  NFT = 2,
}

export const TOKEN_LABEL: LabelValues[] = [
  { label: 'MEY', value: TokenTypeEnum.MEY },
  { label: 'USDC', value: TokenTypeEnum.USDC },
  { label: 'NFT', value: TokenTypeEnum.NFT },
]
